import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const PhotographyPackages = () => {
  useEffect(() => {
    analytics.track('Template Page View', { template: 'Photography Pricing Packages' });
  }, []);

  return (
    <SEOPageLayout
      title="Photography Pricing Packages Template - Earn More Per Shoot | QuoteTier"
      description="Don't just sell your time. Sell prints, albums, and extra hours with this tiered photography pricing template."
      canonical="/templates/photography-pricing-packages"
      ogTitle="Photography Packages That Sell Themselves"
      ogDescription="Standardize your wedding, portrait, or event pricing. Upsell albums and second shooters automatically."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Photography <span className="text-primary font-bold">Pricing</span> Template
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Move beyond hourly rates. Offer comprehensive packages that capture the full value of your art.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Use This Template Free
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">Package Examples</h2>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Essential</CardTitle><CardDescription>Digital Only</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>4 Hours Coverage</li>
                      <li>Online Gallery</li>
                      <li>High-Res Downloads</li>
                      <li>Print Release</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black bg-black text-white">
              <CardHeader><CardTitle className="font-instrument text-xl text-white">Standard</CardTitle><CardDescription className="text-gray-300">Most Popular</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-300 list-disc list-inside">
                      <li>8 Hours Coverage</li>
                      <li>Second Shooter</li>
                      <li>Engagement Session</li>
                      <li>$100 Print Credit</li>
                  </ul>
              </CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Heirloom</CardTitle><CardDescription>Full Experience</CardDescription></CardHeader>
              <CardContent>
                  <ul className="font-jetbrains text-sm text-gray-600 list-disc list-inside">
                      <li>Full Day Coverage</li>
                      <li>Luxury Layflat Album</li>
                      <li>Parent Albums (2)</li>
                      <li>$300 Print Credit</li>
                  </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Professionalize Your Pricing</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Get Free Access
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default PhotographyPackages;
